
const subjects = Object.freeze({
  KOKUGO: 'ko',
  SHAKAI: 'sh',
  SUGAKU: 'su',
  RIKA: 'ri',
  EIGO: 'ei',
  CHIRI1: 'ch1',
  CHIRI2: 'ch2',
  REKISHI1: 're1',
  REKISHI23: 're23',
  KOUMIN: 'mi',
  GIJUTSU: 'gi',
  ZAIRYO: 'za',
  SEIBUTSUIKUSEI: 'se',
  ENERGY: 'en',
  JOHO: 'jo',
  KATEI: 'ka',
  SHOKUSEIKATSU: 'ss',
  ISEIKATSU: 'is',
  SHOHISEIKATSU_KANKYO: 'sk',
  KAZOKU_CHIIKI: 'kc',
  HOKEN_TAIIKU: 'ht',
  HOKEN: 'ho',
  TAIIKU_JITSUGI: 'ta',
  TAIIKU_RIRON: 'tr'
})

const shakaiOptionSubjects = Object.freeze({
  CHIRI1: 'ch1',
  CHIRI2: 'ch2',
  REKISHI1: 're1',
  REKISHI23: 're23',
  KOUMIN: 'mi',
})

const hasOptionSubjects = Object.freeze([
  subjects.SHAKAI,
  subjects.GIJUTSU,
  subjects.KATEI,
  subjects.HOKEN_TAIIKU,
])

const skillSubjects = Object.freeze([
  subjects.GIJUTSU,
  subjects.KATEI,
  subjects.HOKEN_TAIIKU,
])

const publisherNoneSubjecs = Object.freeze([
  subjects.TAIIKU_JITSUGI,
])

const grades = Object.freeze({
  CHU1: 't1',
  CHU2: 't2',
  CHU3: 't3',
})

const difficulties = Object.freeze({
  EASY: '1',
  STANDARD: '2',
  DIFFICULT: '3',
})

const materialKinds = Object.freeze([
  //sheet.jsでの処理用にkeyを`id`にしている
  {id:'general',  name:'新学社教材'},
  {id:'test',     name:'新学社実力テスト'},
  {id:'original', name:'オリジナル問題'},
])

// 解答重複チェックしない解答形式のcode
const nonCheckAnswerFormatCodes = Object.freeze([
  'ko03',
  'su02',
  'ei03',
  'ri01',
  'sh03'
])

const step = Object.freeze({
  REPLACE_CONTENT: 1,
  PREVIEW: 2,
  SCORE_SETTING: 3,
  SHEET_NAMING:4,
  COMPLETED: 5,
})

const materialPasswords = Object.freeze({
  ko_t1: ["a6x9", "u3xj", "v427", "t2rn"],
  ko_t2: ["z8tc", "b85k", "u864", "s5ui"],
  ko_t3: ["r2nb", "t84h", "a5wj", "t8ub"],
  ch1_t1: ["v2ds", "k6pd", "y4sc"],
  re1_t1: ["c3hv", "d973"],
  ch2_t2: ["b8pz", "s42e", "t9zb"],
  re23_t2: ["u5vs", "b47j"],
  mi_t3: ["b25u", "u7k5"],
  re23_t3: ["878e", "k7uc"],
  su_t1: ["q59d", "h8ys", "g5k9", "i73t", "y7r3", "b3nm"],
  su_t2: ["p6b3", "i5av", "s3n9", "h8kw", "p4dn", "k8wy"],
  su_t3: ["h38t", "b9eu", "j8gx", "y8v4", "w8fa", "m2pa"],
  ri_t1: ["c7zi", "m29a", "h2x7", "v5pb", "x268", "w87y"],
  ri_t2: ["y5sk", "u46i", "i8uz", "k6w3", "v4q8", "s4y3"],
  ri_t3: ["y8b4", "p6md", "u62f", "c8xz", "e5hz", "w5rg"],
  ei_t1: ["k2n9", "f6ay", "s24n", "t3v8", "n6yc", "g35p", "r7pm", "y3fg"],
  ei_t2: ["p5s2", "q6eg", "g89y", "c824", "e6np", "f24e", "k456", "y4gi"],
  ei_t3: ["d28g", "h6g8", "s6r4", "h8a3", "n59f", "m6r5", "m7fw", "f4ac"],
  ht_t1: ["fdu3", "x7kw", "es5u", "z53n"],
  ht_t2: ["p8x3", "b2q7", "mp4z", "v3zy"],
  ht_t3: ["a3v5", "c4eb", "s4wk"],
  ht_: ["54u6"],
  gi_t1: ["aw4q", "f89j"],
  gi_t2: ["aw4q", "f89j"],
  gi_t3: ["aw4q", "f89j"],
  ka_t1: ["hxy3", "j5hm"],
  ka_t2: ["hxy3", "j5hm"],
  ka_t3: ["hxy3", "j5hm"]
})

// 更新する場合はteacher.rbのSHINGAKU_EXPIRY_DATESも更新すること
const shingakuMaterialPasswords = Object.freeze({
  2026: {
    start_date: '2025/8/1',
    end_date: '2027/3/31',
    prefix: 'y',
    codes: {
      ko_t2: ["k2xvs"],
      sh_t2: ["f4qw3"],
      su_t2: ["e3jk4"],
      ri_t2: ["q6byu"],
      ei_t2: ["j5vqs"],
    }
  },
  2027: {
    start_date: '2026/10/1',
    end_date: '2028/3/31',
    prefix: 'x',
    codes: {
    }
  },
  2028: {
    start_date: '2027/10/1',
    end_date: '2029/3/31',
    prefix: 'y',
    codes: {
    }
  },
})

const specialSubjectMap = Object.freeze({
  'sh': {
    't1': ['ch1', 're1', 'ch2', 're23'],
    't2': ['ch2', 're23', 'ch1', 're1'],
    't3': ['mi', 'ch2', 're23']
  }
})

export default Object.freeze({
  subjects: subjects,
  shakaiOptionSubjects: shakaiOptionSubjects,
  hasOptionSubjects: hasOptionSubjects,
  skillSubjects: skillSubjects,
  publisherNoneSubjecs: publisherNoneSubjecs,
  grades: grades,
  difficulties: difficulties,
  materialKinds: materialKinds,
  step: step,
  nonCheckAnswerFormatCodes: nonCheckAnswerFormatCodes,
  materialPasswords: materialPasswords,
  shingakuMaterialPasswords: shingakuMaterialPasswords,
  // おためし活動用の認証コード(R8年度: 令和8年8月1日利用開始)
  otameshiMaterialPassword: 'n4kf',
  specialSubjectMap: specialSubjectMap
})
